import { getCookie } from 'lib/utils/cookie';
import { v4 } from 'lib/utils/uuid';

const deviceKey = 'cat-device-id';

export const getDeviceId = () => {
  const cookieId =
    getCookie(deviceKey) ||
    getAndRemoveDeviceIdFromLocalStorage(deviceKey) ||
    v4();

  return cookieId;
};

const getAndRemoveDeviceIdFromLocalStorage = (key: string): string | null => {
  let id;
  try {
    id = window.localStorage.getItem(key);
    if (id) {
      window.localStorage.removeItem(key);
    } else {
      return null;
    }

    return id;
  } catch (e) {
    return null;
  }
};
